"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.govDispenser = void 0;
const govDispenser = {
    appId: 793119194,
    gAlgoId: 793124631,
};
exports.govDispenser = govDispenser;
//# sourceMappingURL=mainnet-constants.js.map